<div class="modal-header">
    <h5 class="modal-title">Adding Third Parties</h5>
</div>
<div class="modal-body">
    <div class="content">
        <div class="form-group cerrix-control-sm">
            <ng-select
                [items]="thirdparties"
                bindLabel="Name"
                bindValue="ID"
                [isOpen]="true"
                [multiple]="true"
                (change)="changed($event)"
            >
                <ng-template ng-option-tmp let-thirdparty="item" let-search="searchTerm">
                    <div class="card" (click)="thirdparty.selected = !thirdparty.selected">
                        <div class="card-body" [class.selected]="thirdparty.selected">
                            @if (thirdparty.selected) {
                                <div>{{ thirdparty.Name }}</div>
                            } @else {
                                <div>
                                    <p class="card-title">{{ thirdparty.Name }}</p>
                                    <p class="card-text">
                                        Outside GDPR jurisdiction:
                                        {{ thirdparty.EUMember ? "Yes" : "No" }}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </ng-template>
            </ng-select>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="okClick()">Ok</button>
    <button type="button" class="btn btn-secondary" (click)="closeClick()">Close</button>
</div>
